// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-sqo8","rootNoMargin":"styles_rootNoMargin__braVf"};